export const LANGUAGE_EN = 'en'
export const LANGUAGE_CN = 'cn'

const projects = {
  Home: 'Home',
  vPage: 'vPage',
  vDialogs: 'vDialogs'
  /* 'vTableGrid': 'v-tablegrid', */
  /* 'vSelectPage': 'v-selectpage', */
  /* 'vSelectMenu': 'v-selectmenu' */
}

export const keys = {
  Home: 'Home',
  Page: 'v-page',
  Dialogs: 'v-dialogs',
  Uploader: 'v-uploader',
  Region: 'v-region',
  SelectPage: 'v-selectpage',
  Suggest: 'v-suggest',
  PlayBack: 'v-playback',
  SelectMenu: 'v-selectmenu',
  Gallery: 'v-gallery'
  /* 'TableGrid': 'v-tablegrid', */
}

export const languages = [
  { key: LANGUAGE_EN, name: 'English' },
  { key: LANGUAGE_CN, name: '简体中文' }
]

export default {
  projects
}
